import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import { landlordReducer } from '@rental-manager/reducers';
import { renterReducer } from '@renter-hub/reducers';
import app from './app';
import user from './user';

const paymentsReducer = combineReducers({
  landlord: landlordReducer,
  renter: renterReducer,
});

const rootReducer = (history: any) =>
  combineReducers({
    app,
    payments: paymentsReducer,
    user,
    router: connectRouter(history),
  });

export default rootReducer;
